import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import Head from 'next/head';
import { PageLayout } from '@/components/pagelay';
import CountUp from 'react-countup';

interface IProps {

}

export default (props: any) => {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const width = window?.innerWidth    
    setZoom(width > 580 ? 1 : 0.014 + width * 0.0017);
  }, []);

  return (
    <PageLayout>
      <div className={styles.container}>
        <div className={styles.intro}>
          <div className={styles.left}>
            <h2>亚洲有机产业展览会</h2>
            <div className={styles.info}>
              <p className={styles.site}>
                <span>上海新国际博览中心</span>
              </p>
              <p className={styles.time}>
                <span>2025年9月03-05日</span>
              </p>
            </div>
            <p>随着居民生活水平的不断提高，有机产品以其天然、无污染、健康的特性，正逐渐成为消费的热选。消费者对有机产品的青睐不仅源于对自身健康的关注，更是对环境保护和可持续发展理念的积极践行。全球对有机产品的需求，因此持续攀升，有机生活方式日益受到更广泛关注。</p>
            <p>近年来，中国有机产业增长迅猛，截至2023年，中国有机产业销售额已成功突破1000亿元人民币大关，已稳步跻身全球第三大有机消费市场。</p>
            <p>亚洲有机产业展览会(Organic Festa Asia)应运而生，将于2025年在中国上海与大家见面。这一盛会旨在搭建一个集展示、交流、合作和推广于一体的综合性平台，汇聚全球有机产业的优质资源，推动有机产业在中国、亚洲乃至全球的深度发展。</p>
            <p>我们诚挚邀请您加入这一充满机遇与活力的有机行业盛会，共同开启有机产业的新篇章。</p>
            <div className={styles.sponsors}>
              <h3>主办方</h3>
              <div>
                <div>
                  <img src="/image/sponsor1.png" alt="" />
                  <div>
                    <p>国际有机农业亚洲联盟</p>
                    <p>IFOAM-Organics Asia</p>
                  </div>
                </div>
                <div>
                  <img src="/image/sponsor2.png" alt="" />
                  <div>
                    <p>杜塞尔多夫展览（上海）有限公司</p>
                    <p>Messe Düsseldorf(Shanghai)Co.,Ltd.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.right} style={{ zoom }}>
            <div className={styles.leftDrop}>
              <div className={styles.dropBig}>
                <p>
                  <CountUp
                    end={13000}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>参观人数</span>
              </div>
              <div className={styles.dropSmall} style={{ marginRight: '15px' }}>
                <p>
                  <CountUp
                    end={300}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>海内外专业展商</span>
              </div>
            </div>
            <div className={styles.rightDrop}>
              <div className={styles.dropSmall} style={{ marginLeft: '15px' }}>
                <p>
                  <CountUp
                    end={30}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>同期活动</span>
              </div>
              <div className={styles.dropBig}>
                <p>
                  <CountUp
                    end={12000}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>㎡</span>
                </p>
                <span>展览面积</span>
              </div>
              <div className={styles.dropSmall} style={{ margin: '-35px 0 0 -45px' }}>
                <p>
                  <CountUp
                    end={50}
                    duration={1}
                    enableScrollSpy
                  />
                  <span>+</span>
                </p>
                <span>展会年内全国活动</span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.photos}>
          <img src="/image/photo (1).png" alt="" />
          <img src="/image/photo (2).png" alt="" />
          <img src="/image/photo (3).png" alt="" />
          <img src="/image/photo (4).png" alt="" />
          <img src="/image/photo (5).png" alt="" />
          <img src="/image/photo (6).png" alt="" />
        </div>
      </div>
    </PageLayout>

  );
};


